/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investment return calculator`)
};

const es_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de retornos de inversión`)
};

const de_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlage-Rendite-Rechner`)
};

const nl_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beleggingsrendementsberekening`)
};

const fr_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice de rendement d'investissement`)
};

const it_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore del rendimento degli investimenti`)
};

const pt_br2_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de retorno de investimento`)
};

const pt_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de retorno de investimento`)
};

const ja_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投資リターン計算機`)
};

const zh_sip_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投资收益计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_nav_calc_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_nav_calc_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_nav_calc_desc", locale)
	if (locale === "en") return en_sip_nav_calc_desc(inputs)
	if (locale === "es") return es_sip_nav_calc_desc(inputs)
	if (locale === "de") return de_sip_nav_calc_desc(inputs)
	if (locale === "nl") return nl_sip_nav_calc_desc(inputs)
	if (locale === "fr") return fr_sip_nav_calc_desc(inputs)
	if (locale === "it") return it_sip_nav_calc_desc(inputs)
	if (locale === "pt-BR") return pt_br2_sip_nav_calc_desc(inputs)
	if (locale === "pt") return pt_sip_nav_calc_desc(inputs)
	if (locale === "ja") return ja_sip_nav_calc_desc(inputs)
	return zh_sip_nav_calc_desc(inputs)
};